import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import React from 'react'

import styles from './Subbanner.module.scss'
import { SubbannerVideo } from '../../components/SubbannerVideo/SubbannerVideo'

export type ZoneSubbannerProps = {
  __typename: 'StrapiGQL_ComponentZonesSubbanner'
  isVideo?: boolean
  video_url?: string
  subbannerTitle?: string
  devByAlgbraLabs?: boolean
  image?: GatsbyResolvedAsset
  youtube_code?: string
  isPlaylist?: boolean
}

export default function ZoneSubbanner(props: ZoneSubbannerProps) {
  const {
    isVideo,
    video_url,
    subbannerTitle,
    devByAlgbraLabs,
    image,
    youtube_code,
    isPlaylist,
  } = props

  return (
    <Whitespace type="lg">
      <div className={styles.container}>
        {isVideo && (
          <SubbannerVideo
            video_url={video_url}
            devByAlgbraLabs={devByAlgbraLabs}
            title={subbannerTitle}
            youtube_code={youtube_code}
            isPlaylist={isPlaylist}
          />
        )}
      </div>
    </Whitespace>
  )
}
